import { StyleSheet } from 'react-native';
import { Surface, useTheme } from 'react-native-paper';

import { OwnerOnboardingChatView } from '@/src/features/onboarding/useOwnerOnboardingChat';

/**
 * Owner onboarding — one continuous chat (M13 funnel B1). This is the
 * STANDALONE entry point kept for returning owners (login/reload land here via
 * the onboarding redirect). The step logic lives in `useOwnerOnboardingChat`
 * so the exact same conversation can also render inline at the end of the
 * registration chat with no route hop (see app/register/owner.tsx).
 */
export default function OwnerPlanChatScreen() {
  const theme = useTheme();

  return (
    <Surface style={[styles.container, { backgroundColor: theme.colors.background }]}>
      <OwnerOnboardingChatView testID="owner-plan-chat" />
    </Surface>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
